import { Tooltip } from '@sanlam-glacier/app-common/components';
import { clsx } from 'clsx';
import { Section14UrgencyTab } from 'modules/my-practice/types/section-14/section-14.enums';
import styles from './information-indicator.module.scss';

type InformationIndicatorProps = {
  lateRenewalsInfo: number | undefined;
  upcomingRenewalsInfo: number | undefined;
  activeTab: Section14UrgencyTab;
};

export const InformationIndicator = ({
  lateRenewalsInfo,
  upcomingRenewalsInfo,
  activeTab
}: InformationIndicatorProps) => {
  const testComponentName = 'informationIndicator';

  if (activeTab === Section14UrgencyTab.upcoming) {
    if (lateRenewalsInfo === undefined) {
      return <></>;
    }
    return (
      lateRenewalsInfo > 0 && (
        <Tooltip
          data-testid={`${testComponentName}otherLateRenewalsToolip`}
          position={Tooltip.POSITION.TOP}
          content={`${lateRenewalsInfo} other late renewals`}
        >
          <span
            data-testid={`${testComponentName}otherLateRenewalsIndicator`}
            className={clsx(styles.informationIndicator, styles.lateIndicator)}
          />
        </Tooltip>
      )
    );
  }

  if (activeTab === Section14UrgencyTab.late) {
    if (upcomingRenewalsInfo === undefined) {
      return <></>;
    }
    return (
      upcomingRenewalsInfo > 0 && (
        <Tooltip
          data-testid={`${testComponentName}otherUpcomingRenewalsToolip`}
          position={Tooltip.POSITION.TOP}
          content={`${upcomingRenewalsInfo} other upcoming renewals`}
        >
          <span
            data-testid={`${testComponentName}otherUpcomingRenewalsIndicator`}
            className={clsx(styles.informationIndicator, styles.upcomingIndicator)}
          />
        </Tooltip>
      )
    );
  }

  return <></>;
};
